import $ from "jquery";
window.$ = window.jQuery = $;

import "../Scripts/site.js";
import "../Scripts/global/common/jquery.unobtrusive-ajax.js";
import "lazysizes";
import Mount from "./helpers/mount";

import { loginSessionInit } from "./global/modules/loginSession";
import { oauthFunctions } from "./global/modules/oauth_wp";
import { googleLoginFunctions } from "./global/modules/google_wp";
import * as bambuser from "./global/modules/bambuser_wp";
import Menu from "./global/modules/menus_wp";
import { checkoutFunctions, initCheckout } from "./global/modules/checkout_wp";
import * as customerClub from "./global/modules/customerclub_wp";
import * as customerService from "./global/modules/customerservice";
import * as delivery from "./global/modules/delivery_wp";
import * as inventory from "./global/modules/inventory_wp";
import { updateFavorites, initFavorites } from "./global/modules/favorite_wp";
import * as filter from "./global/modules/filter_wp";
import { initForms } from "./global/modules/forms_wp";
import * as gtmdata from "./global/modules/gtmdata_wp";
import * as jeansguide from "./global/modules/jeansguide_wp";
import { initToggle } from "./global/modules/toggler_wp";
import Mypage, { myPageFunctions } from "./global/modules/mypage_wp";
import * as popup from "./global/modules/popup_wp";
import Product from "./global/modules/product_wp";
import * as promotions from "./global/modules/promotions_wp";
import Quantity from "./global/modules/quantity_wp";
import Quicksearch from "./global/modules/quicksearch_wp";
import * as slickslide from "./global/modules/slickslide_wp";
import * as videoStructuredData from "./global/modules/structured-video-data_wp";
import * as tabs from "./global/modules/tabs_wp";
import * as teaserblock from "./global/modules/teaserblock_wp";
import * as video from "./global/modules/video_wp";
import VimeoBlock from "./global/modules/vimeo-block_wp";
import * as afterpay from "./global/modules/afterpay_wp";
import Chat from "./global/modules/chat_wp";
import apps from "./global/apps.ts";
import MyPageTracking from "./global/modules/mypage_tracking.ts";
import DeleteProfile from "./global/modules/mypage_delete_profile";
import ResetPassword from "./global/modules/mypage_reset_password";
import ChangeLoyaltyEmail from "./global/modules/mypage_change_loyalty_email";
import HeaderBanner from "./global/modules/header_banner";
import NewsletterSignupForm from "./global/modules/newsletter_signup_form/newsletter_signup_form";
import HeroBlockHenryVideo from "./global/modules/henry_hero_block_video";
import EpiserverUploadReload from "./global/modules/episerver_upload_reload.ts";
import showPorterBuddyWidget from "./global/modules/porterbuddy-widget.ts";
import PromotionTracking from "./global/modules/content_performance_tracking";
import VideoBlock from "./global/modules/video_block.ts";
import ProductCarousel from "./global/modules/product_carousel.js";
import splitting from "splitting";
import TopBand from "./global/modules/top-band.ts";
import VoyadoEngageClearCart from "./global/modules/voyadoEngageClearCart.ts";

if (import.meta.env.DEV) {
    const bodyClassList = document.body.classList;
    if (bodyClassList.contains("decades")) {
        import("../Styles/decades.scss");
    }
    if (bodyClassList.contains("jeanpaul")) {
        import("../Styles/jean-paul.scss");
    }
    if (bodyClassList.contains("match")) {
        import("../Styles/match-fashion.scss");
    }
    if (bodyClassList.contains("boys")) {
        import("../Styles/boys-of-europe.scss");
    }
    if (bodyClassList.contains("vic")) {
        import("../Styles/vic.scss");
    }
    if (bodyClassList.contains("voice")) {
        import("../Styles/voice.scss");
    }
    if (bodyClassList.contains("henrychoice")) {
        import("../Styles/henry-choice.scss");
    }
}

window.voice = {};

window.voice.loginSession = loginSessionInit;
loginSessionInit();
showPorterBuddyWidget();
bambuser.init();
Mount("_js-nav-main", Menu);
customerClub.init();
customerService.init();
filter.init();
window.voice.initForms = initForms;
initForms();
gtmdata.init();
jeansguide.init();
inventory.init();
window.voice.oauth = oauthFunctions;
window.voice.googleLogin = googleLoginFunctions;
Mount("layout-mypage", Mypage);
window.voice.mypage = myPageFunctions;
popup.init();
promotions.init();
Mount("page-actions__search", Quicksearch);
teaserblock.init();
video.init();
Mount("_js-vimeo-block", VimeoBlock);
videoStructuredData.init();
initFavorites();
afterpay.init();
Mount("_js-openchat", Chat);
window.voice.updateFavorites = updateFavorites;
window.voice.initToggle = initToggle;
initToggle();
splitting({target: "._js-splitting"});

Mount("_js-mypage-tracking", MyPageTracking);
Mount("_js-mypage-delete-profile", DeleteProfile);
Mount("_js-mypage-reset-password", ResetPassword);
Mount("_js-change-loyalty-club-email", ChangeLoyaltyEmail);
Mount("_js-newsletter-signup", NewsletterSignupForm);
Mount("header-banner", HeaderBanner);
Mount("_js-hero-block-henry-video", HeroBlockHenryVideo);
Mount("html", EpiserverUploadReload);
Mount("_js_promotion-tracking", PromotionTracking);
Mount("_js-video-block", VideoBlock);
Mount("_js-top-band", TopBand);
Mount("_js_product-carousel", ProductCarousel);
Mount("_js-video-block", VideoBlock);
Mount("_js-voyado-engage-clear-cart", VoyadoEngageClearCart);

//Kan nok inkluderes kun på /sok?
tabs.init();
//Kan nok inkluderes kun på /handlekurv
Mount("_js-checkout", Quantity);

//Kan nok inkluderes kun på produktsider
slickslide.init();
Mount("_js-product-index", Product);

//Kan nok inkluderes kun i checkout views
initCheckout();

//Kan nok inkluderes kun i delivery-steg
delivery.init();

//Kan nok inkluderes kun i checkout views
window.voice.checkout = checkoutFunctions;

window.voice.pinterest = () => {
    return {
        share: () => {
            window.PinUtils.pinAny();
        },
    };
};

apps.init();

//Remove no-js class from body. This was being done with modernizr before,
//but not much else of modernizr was being used.
document.onreadystatechange = function () {
    if (document.readyState === "complete") {
        document.documentElement.classList.remove("no-js");
        document.documentElement.classList.add("js");
    }

    //Load partial contents
    $(".partialContents").each(function (index, item) {
        const url = $(item).data("url");
        if (url && url.length > 0) {
            $(item).load(url);
        }
    });
};
